/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRotateV: {
  name: 'arrows-rotate-v';
  data: string;
} = {
  name: 'arrows-rotate-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.046 2.701a1 1 0 0 1 1.253-.655l4 1.252a1 1 0 0 1 .667 1.212l-1 3.748a1 1 0 0 1-1.932-.516l.485-1.817a7.003 7.003 0 0 0 .857 12.566 1 1 0 1 1-.751 1.854A9.003 9.003 0 0 1 7.16 4.411l-1.459-.457a1 1 0 0 1-.655-1.253Zm9.027 1.505a1 1 0 0 1 1.302-.551 9.003 9.003 0 0 1 1.465 15.934l1.459.457a1 1 0 0 1-.598 1.908l-4-1.252a1 1 0 0 1-.667-1.212l1-3.748a1 1 0 0 1 1.932.516l-.484 1.817a7.003 7.003 0 0 0-.857-12.566 1 1 0 0 1-.552-1.303Z" fill="currentColor"/></svg>`,
};
